var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgStage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 878 613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M833.16,234.93c49.43,110.23,44.63,279.32-110.74,320.64-215.42,57.29-669.38,89.25-702.44-112.39C.82,326.28,56.45,140.35,274.92,96.56c217.96-43.69,491.97-9.4,558.24,138.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M788.32,56.61c0,23.63-31.81,46.08-60.9,46.08s-67.48-19.16-67.48-42.79,41.68-49.38,70.77-49.38,57.6,22.45,57.6,46.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M805.77,134.33c-10.04-7.95-11.88-25.22-4.84-34.12,7.04-8.89,24.47-14.19,34.51-6.25,10.04,7.95,10.89,29.35,3.85,38.24-7.04,8.89-23.48,10.07-33.52,2.12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStage);
export default __webpack_public_path__ + "static/media/bg_stage.e03c5a173f57c095e7c8fef5d9d9d17b.svg";
export { ForwardRef as ReactComponent };